import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "member_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const memberApi = {
  register: (data) => axios.post(`${API}/members/register`, data).then((r) => r.data),
  login: (data) => axios.post(`${API}/members/login`, data).then((r) => r.data),
  forgot: (email) => axios.post(`${API}/members/forgot`, { email }).then((r) => r.data),
  reset: (token, password) => axios.post(`${API}/members/reset`, { token, password }).then((r) => r.data),
  updateMe: (data) => axios.put(`${API}/members/me`, data, authHeaders()).then((r) => r.data),
  changePassword: (data) => axios.put(`${API}/members/me/password`, data, authHeaders()).then((r) => r.data),
  me: () => axios.get(`${API}/members/me`, authHeaders()).then((r) => r.data),
  dashboard: () => axios.get(`${API}/members/dashboard`, authHeaders()).then((r) => r.data),
  download: async (file) => {
    const res = await axios.get(`${API}/members/files/${file.id}`, { ...authHeaders(), responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = Object.assign(document.createElement("a"), { href: url, download: file.original_filename });
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Κάτι πήγε στραβά. Δοκιμάστε ξανά.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const GRADES = ["Α' Γυμνασίου", "Β' Γυμνασίου", "Γ' Γυμνασίου", "Α' Λυκείου", "Β' Λυκείου", "Γ' Λυκείου"];
export const SUBJECTS = ["Φυσική", "Χημεία", "Μαθηματικά", "Βιολογία", "Έκθεση", "Αρχαία", "Πληροφορική", "Οικονομία", "Άλλο"];
export const ROLE_LABEL = { student: "Μαθητής", parent: "Γονέας", teacher: "Καθηγητής" };
export const EVAL_CRITERIA = [["participation", "Συμμετοχή"], ["homework", "Εργασίες στο σπίτι"], ["understanding", "Κατανόηση ύλης"], ["consistency", "Συνέπεια / Συμπεριφορά"]];

export const staffApi = (cfg) => ({
  students: () => axios.get(`${API}/staff/students`, cfg).then((r) => r.data),
  grades: (id) => axios.get(`${API}/staff/students/${id}/grades`, cfg).then((r) => r.data),
  addGrade: (data) => axios.post(`${API}/staff/grades`, data, cfg).then((r) => r.data),
  delGrade: (id) => axios.delete(`${API}/staff/grades/${id}`, cfg).then((r) => r.data),
  evaluations: (id) => axios.get(`${API}/staff/students/${id}/evaluations`, cfg).then((r) => r.data),
  addEvaluation: (data) => axios.post(`${API}/staff/evaluations`, data, cfg).then((r) => r.data),
  delEvaluation: (id) => axios.delete(`${API}/staff/evaluations/${id}`, cfg).then((r) => r.data),
  sendEvaluation: (id, to = "") => axios.post(`${API}/staff/evaluations/${id}/send`, { to }, cfg).then((r) => r.data),
});
